import { jsx } from "react/jsx-runtime";
import { u as useToggletip, T as ToggletipContext } from "../../../../chunks/useToggletip-BRp4_0cB.js";
function ToggletipContainer({
  children,
  initialOpen,
  placement,
  open,
  onOpenChange,
  ...props
}) {
  const toggletip = useToggletip({ initialOpen, placement, open, onOpenChange });
  return /* @__PURE__ */ jsx(ToggletipContext.Provider, { value: toggletip, children: /* @__PURE__ */ jsx("div", { ...props, children }) });
}
export {
  ToggletipContainer
};
